'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['width', 'w', 'm', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'flex', 'order', 'wrap', 'direction', 'align', 'justify', 'column'];


//////////////////
// WEBPACK FOOTER
// ./~/grid-styled/dist/remove-props.js
// module id = 168
// module chunks = 35783957827783 64089156084587 91322373450782 114276838955818